import script from "./BillingWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingWrapper.vue?vue&type=script&setup=true&lang=js"

import "./BillingWrapper.vue?vue&type=style&index=0&id=15e70d26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15e70d26"]])

export default __exports__